
import { useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useAuthStore } from '../Store/Slices/AuthSlice';
import { useCurrentBot } from '../Store/Slices/DashboardSlices';
import { useAppSelector } from '../Store';
import { domainDetails } from '../Store/Slices/SubAccount/subaccount.selectors';

const useDocumentTitle=(title:string, prevailOnUnmount = false)=>{
  // const defaultTitle = useRef(document.title);
  const currentBot = useSelector(useCurrentBot);
  const { data: authData,userConfig} = useSelector(useAuthStore);
  const domainDetailsData:any=useAppSelector(domainDetails)

  const businessName=domainDetailsData?.name
  const businessTitle = businessName 
  ? businessName.charAt(0).toUpperCase() + businessName.slice(1) 
  : "Wabo";

  const defaultTitle=businessTitle;

  const updateFavicon = (iconUrl: string) => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (link) {
      link.href = iconUrl;
    } else {
      link = document.createElement("link");
      link.rel = "icon";
      link.href = iconUrl;
      document.head.appendChild(link);
    }
  };
  
  useLayoutEffect(() => {
    if (authData && authData?.data && authData?.data?.user && authData?.data?.user?.first_name) {
      if (title) {
        document.title = `${title} | ${authData?.data?.user?.first_name}`;
          
      }
      else {
        document.title = `${businessTitle} | ${authData?.data?.user?.first_name}`;
      }
    }
      else {
        document.title = `${businessTitle} | Wabo`;
      }
      const faviconUrl = window.location.hostname !== process.env.REACT_APP_DOMAIN_NAME ? domainDetailsData?.logo : (window.location.hostname === process.env.REACT_APP_DOMAIN_NAME) ? "/favicon.png" : ""; 
      updateFavicon(faviconUrl);
     
  }, [title, currentBot, authData?.data?.user,domainDetailsData?.logo]);  // eslint-disable-line react-hooks/exhaustive-deps


  useLayoutEffect(() => () => {
    if (!prevailOnUnmount) {
      // document.title = defaultTitle.current;
      document.title=defaultTitle;
    }
  }, [])  // eslint-disable-line react-hooks/exhaustive-deps
}

export default useDocumentTitle;